import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { ScenarioPlanningApi } from "../../../api";

export const scenarioPlanningKeys = {
  all: () => ["scenarioPlanning"],
  parameters: () => ["scenarioPlanningParameters"],
  pathways: () => ["decarbonizationPathways"]
};

export function useCalculateScenarioPlanning(params, config) {
  const { callApi } = useAuth();

  return useQuery([scenarioPlanningKeys.all(), params.pathwayId],
    () => callApi(ScenarioPlanningApi.calculateScenarioPlanning, params), {
      ...config,
      enabled: params.enabled
    });
}

export function useGetScenarioPlanningParameters(config) {
  const { callApi } = useAuth();

  return useQuery(scenarioPlanningKeys.parameters(),
    () => callApi(ScenarioPlanningApi.getScenarioPlanningParameters), config);
}

export function useExportScenarioPlanningChartData(config) {
  const { callApi } = useAuth();
  return useMutation(({ params }) => callApi(ScenarioPlanningApi.exportChartData, params), config);
}

export function useGetDecarbonizationPathways(config) {
  const { callApi } = useAuth();

  return useQuery(scenarioPlanningKeys.pathways(),
    () => callApi(ScenarioPlanningApi.getDecarbonizationPathways), config);
}